import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Input } from 'react-materialize';
import { FormattedMessage, injectIntl } from 'react-intl';

import Logger from '../../functions/logging';

import { getUser, updateUserDemographics, updateProfilePrivacy, updateUserPassword, updateUserMonitor } from '../../api/user';

import '../../static/home/Profile.css';

import * as auth from '../../functions/auth';
import PageLoader from '../global/PageLoader';
import FadeIn from '../global/FadeIn';

import localeMessages from '../../locales/profile';
import localeEducation from '../../locales/education';
import localeEthnicity from '../../locales/ethnicity';

import { setCurrentUser } from '../../redux/actions/index';

class Profile extends Component {
	constructor(props) {
		super(props);

		let education = props.currentUser && (props.currentUser.user_demographic.education || props.currentUser.user_demographic.education === 0) ? props.currentUser.user_demographic.education : "";

		this.state = {
			isWindowSelectSet: false,
			isEthnicitySelectSet: false,
			isEducationSelectSet: false,

			user: {
				hhi: props.currentUser ? props.currentUser.user_demographic.hhi : "",
				ethnicity: props.currentUser ? props.currentUser.user_demographic.ethnicity.split(",") : [],
				education: education,
				feedback_basic: 0,
				feedback_pro: 0,

				new_password: "",
				confirm_password: "",
				old_password: ""
			},
			errors: {},
			loading: false,
			demographicsLoading: false,
			passwordLoading: false,
			emailLoading: false,
		};

		this.setDocumentSelect = this.setDocumentSelect.bind(this);

		this.loadUser = this.loadUser.bind(this);
		this.updateUserDemographics = this.updateUserDemographics.bind(this);
		this.updateUserProfilePrivacy = this.updateUserProfilePrivacy.bind(this);
		this.updateUserPassword = this.updateUserPassword.bind(this);

		this.validatePasswords = this.validatePasswords.bind(this);

		this.handleChange = this.handleChange.bind(this);
		this.handleEthnicitySelect = this.handleEthnicitySelect.bind(this);
		this.handleEducationSelect = this.handleEducationSelect.bind(this);
		this.handleProfilePrivacy = this.handleProfilePrivacy.bind(this);
	}

	componentDidMount() {
		// this.setDocumentSelect();
		let user_token = auth.getToken();
		if (user_token && !this.props.currentUser) {
			this.loadUser(user_token, true);
		}

		if (user_token && this.props.currentUser) {
			this.updateUserMonitor(this.props.currentUser.user_id, user_token, this.props.userPilotlyPoints, "profile_view");
		}
	}

	componentDidUpdate() {
		// this.setDocumentSelect();
	}

	setDocumentSelect() {
		if (!this.state.isWindowSelectSet && document.getElementsByTagName('select')) {
			this.setState({ isWindowSelectSet: true }, () => {
				window.$(document).ready(() => {
					window.$('select').formSelect();
				});
			});
		}

		if (!this.state.isEthnicitySelectSet && document.getElementById('ethnicity')) {
			this.setState({ isEthnicitySelectSet: true }, () => {
				window.$(document).ready(() => {
					window.$('select').formSelect();
				});

				window.$('#ethnicity').on('change', (e) => {
					this.handleEthnicitySelect(e);
				}).formSelect();
			});
		}

		if (!this.state.isEducationSelectSet && document.getElementById('education')) {
			this.setState({ isEducationSelectSet: true }, () => {
				window.$(document).ready(() => {
					window.$('select').formSelect();
				});

				window.$('#education').on('change', (e) => {
					this.handleEducationSelect(e);
				}).formSelect();
			});
		}
	}

	/***** aync calls *****/
	async loadUser(user_token, settingState) {
		try {
			const result = await getUser(user_token);
			if (result) {
				Logger.log(this.constructor.name, "loadUser() User Success", result);
				let user = {
					hhi: result.user_demographic.hhi,
					ethnicity: result.user_demographic.ethnicity.split(","),
					education: result.user_demographic.education,
					feedback_basic: result.user_profile_privacy.feedback_basic,
					feedback_pro: result.user_profile_privacy.feedback_pro
				};
				if (settingState) this.setState({ user: user });
				this.props.setCurrentUser(result);
			}
			else {
				Logger.log(this.constructor.name, "loadUser() User Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.profile_error_loading_user);
				this.setState({ errors });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "loadUser() User Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.profile_error_loading_user);
			this.setState({ errors });
		}
	}

	async updateUserDemographics(event) {
		event.preventDefault();

		let userClone = { ...this.state.user };
		let user_token = auth.getToken();
		Logger.log(this.constructor.name, "updateUserDemographics(): USER FIELDS: " + userClone);
		this.setState({ demographicsLoading: true });

		userClone.ethnicity = userClone.ethnicity.toString();
		userClone.user_id = this.props.currentUser.user_id;

		try {
			const result = await updateUserDemographics(userClone, user_token);
			if (result) {
				Logger.log(this.constructor.name, "Update Successful", result);
				this.setState({ demographicsLoading: false, errors: {}, displayDemographicsSuccess: true }, () => {
					this.loadUser(user_token);
					setTimeout(() => {
						this.setState({ displayDemographicsSuccess:false });
					}, 2000);
				});
			}
			else {
				Logger.log(this.constructor.name, "Update Demographics Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["status"] = this.props.intl.formatMessage(localeMessages.profile_error_updating_user);
				this.setState({ errors: errors, demographicsLoading: false });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "Update Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.profile_error_updating_user);
			this.setState({ errors: errors, demographicsLoading: false });
		}
	}

	async updateUserProfilePrivacy(event) {
		let userClone = { ...this.state.user };
		let user_token = auth.getToken();
		Logger.log(this.constructor.name, "updateUserProfilePrivacy(): USER FIELDS: " + userClone);

		let userData = {
			feedback_basic: userClone.feedback_basic,
			feedback_pro: userClone.feedback_pro,
			user_id: this.props.currentUser.user_id,
		};

		try {
			const result = await updateProfilePrivacy(userData, user_token);
			if (result) {
				Logger.log(this.constructor.name, "Update Profile Privacy Successful", result);
				this.setState({ loading: false, errors: {} }, () => {
					this.loadUser(user_token);
				});
			}
			else {
				Logger.log(this.constructor.name, "Update Profile Privacy Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["status"] = this.props.intl.formatMessage(localeMessages.profile_error_updating_user);
				this.setState({ errors: errors, loading: false });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "Update Profile Privacy Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.profile_error_updating_user);
			this.setState({ errors: errors, loading: false });
		}
	}

	async updateUserPassword(event) {
		let userClone = { ...this.state.user };
		let user_token = auth.getToken();
		let userData = {
			new_password: userClone.new_password,
			old_password: userClone.old_password,
			user_token: user_token,
			email: this.props.currentUser.email,
			user_id: this.props.currentUser.user_id,
		};

		Logger.log(this.constructor.name, "updateUserPassword(): USER FIELDS: " + userData);
		this.setState({ passwordLoading: true });
		try {
			const result = await updateUserPassword(userData, user_token);
			if (result) {
				Logger.log(this.constructor.name, "Update Password Successful", result);
				this.setState({ passwordLoading: false, errors: {}, displayPasswordSuccess: true }, () => {
					setTimeout(() => {
						this.setState({displayPasswordSuccess: false});
					}, 2000);
				});
			}
			else {
				Logger.log(this.constructor.name, "Update Password Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["password"] = this.props.intl.formatMessage(localeMessages.profile_error_updating_password);
				this.setState({ errors: errors, passwordLoading: false });
			}
		}
		catch (error) {
			Logger.log(this.constructor.name, "Update Password Failed", error);
			let errors = { ...this.state.errors };
			if (error.error === 400) {
				errors["password"] = this.props.intl.formatMessage(localeMessages.profile_error_invalid_password);
			} 
			else {
				errors["password"] = this.props.intl.formatMessage(localeMessages.profile_error_updating_password);
			}
			this.setState({ errors: errors, passwordLoading: false });
		}
	}

	async updateUserMonitor(user_id, user_token, points, last_view) {
		Logger.log(this.constructor.name, "updateUserMonitor(): USER TOKEN: " + user_token + " USER_ID: " + user_id);

		try {
			const result = await updateUserMonitor(user_id, user_token, points, last_view);
			if (result) {
				Logger.log(this.constructor.name, "UPDATE User Monitor Successful", result);
				this.setState({ errors: {} });
				this.props.setUserMonitor(result);
			}
			else {
				Logger.log(this.constructor.name, "UPDATE User Monitor: No result token/user_id???");
				let errors = { ...this.state.errors };
				errors["status"] = this.props.intl.formatMessage(localeMessages.profile_error_loading_user);
				this.setState({ errors: errors });

			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "UPDATE User Monitor Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.profile_error_loading_user);
			this.setState({ errors: errors });
		}
	}

	/***** validate functions *****/
	validatePasswords(event) {
		event.preventDefault();

		let userClone = { ...this.state.user };
		let errors = {};
		if (!userClone.new_password || !userClone.confirm_password) {
			errors['password'] = this.props.intl.formatMessage(localeMessages.error_passwords_missing);
		}
		if (userClone.new_password !== userClone.confirm_password) {
			errors['password'] = this.props.intl.formatMessage(localeMessages.error_passwords_confirm);
		}

		if (Object.keys(errors).length) {
			this.setState({ errors });
		} else {
			this.setState({ errors: {} }, () => {
				this.updateUserPassword();
			});
		}
	}

	/***** state updates *****/
	handleChange(event) {
		let key = event.target.name;
		let value = event.target.value;
		let userClone = { ...this.state.user };
		userClone[key] = value;
		this.setState({ user: userClone });
	}

	handleEthnicitySelect(event) {
		let userClone = { ...this.state.user };
		let ethnicties = [];
		if (event.target.selectedOptions && event.target.selectedOptions.length) {
			for (let i = 0; i < event.target.selectedOptions.length; i++) {
				let option = event.target.selectedOptions[i];
				ethnicties.push(option.value);
			}
		}
		userClone['ethnicity'] = ethnicties;

		Logger.log(this.constructor.name, "handleEthnicitySelect()", userClone);
		this.setState({ user: userClone, errors: {} });
	}

	handleEducationSelect(event) {
		let userClone = { ...this.state.user };
		let value = event.target.value;
		userClone['education'] = value;

		Logger.log(this.constructor.name, "handleEducationSelect()", userClone);
		this.setState({ user: userClone, errors: {} });
	}

	handleProfilePrivacy(event) {
		let key = event.target.name;
		let value = event.target.checked ? 1 : 0;
		let userClone = { ...this.state.user };
		userClone[key] = value;
		this.setState({ user: userClone }, () => { this.updateUserProfilePrivacy(); });
	}

	render() {
		Logger.log(this.constructor.name, "render()", this.props, this.state);

		const { currentUser } = this.props;

		return (
			<FadeIn>
				<div className="pilotly-home-active">
					<div className="pilotly-profile-header">
						<h1>
							<FormattedMessage
								id="profile.title"
								defaultMessage={`Profile`}
							/>							
						</h1>
						<p>
							<FormattedMessage
								id="profile.subheading"
								defaultMessage={`Adjust your account information and security settings below`}
							/>							
						</p>
					</div>

					<div className="pilotly-profile-account-settings mt-30">
						<div className="section-heading">
							<FormattedMessage
								id="profile.heading.change_email"
								defaultMessage={`Email`}
							/>
						</div>

						<div className="pilotly-profile-account-settings-form">
							<PageLoader addedClass="pilotly-blue-background" loading={this.state.emailLoading} small={true} />
							<div className="input-field col s6 m-0">
								<span>{currentUser ? currentUser.email: "N/A"}</span>
							</div>
						</div>
					</div>

					<div className="pilotly-profile-account-settings mt-30">
						<div className="section-heading">
							<FormattedMessage
								id="profile.heading.change_password"
								defaultMessage={`Change Password`}
							/>							
						</div>

						<form onSubmit={this.validatePasswords}>
							<div className="pilotly-profile-account-settings-form">
								<PageLoader addedClass="pilotly-blue-background" loading={this.state.passwordLoading} small={true} />
								<div className="input-field col s6">
									<Input name="old_password"
										label={this.props.intl.formatMessage(localeMessages.current_password)}
										type="password"
										value={this.state.user.old_password}
										onChange={this.handleChange}>
									</Input>
								</div>

								<div className="input-field col s6">
									<Input name="new_password"
										label={this.props.intl.formatMessage(localeMessages.new_password)}
										type="password"
										value={this.state.user.new_password}
										onChange={this.handleChange}>
									</Input>
								</div>

								<div className="input-field col s6">
									<Input name="confirm_password"
										label={this.props.intl.formatMessage(localeMessages.confirm_password)}
										type="password"
										value={this.state.user.confirm_password}
										onChange={this.handleChange}>
									</Input>
								</div>

								<div className="confirmation-row">
									<p className={"profile-message" + (this.state.errors.password ? " error" : (this.state.displayPasswordSuccess ? " success" : ""))}>
										{this.state.errors.password || this.props.intl.formatMessage(localeMessages.password_updated)} 
									</p>
									<Button className="waves-effect waves-light"
										type='submit'
										onClick={this.validatePasswords}
									>
										<FormattedMessage
											id="profile.button.update_password"
											defaultMessage={`Update Password`}
										/>							
									</Button>
								</div>
							</div>
						</form>
					</div>

					<div className="pilotly-profile-account-settings mt-30 mb-30">
						<form onSubmit={this.updateUserDemographics}>
							<div className="section-heading">
								<FormattedMessage
									id="profile.heading.user_information"
									defaultMessage={`User Information`}
								/>							
							</div>
							
							<div className="pilotly-profile-account-settings-form">
								<PageLoader addedClass="pilotly-blue-background" loading={this.state.demographicsLoading} small={true} />
								<div className="input-field col s6 mt-30">
									<Input 
										labelClassName="active" 
										label={this.props.intl.formatMessage(localeMessages.household_income)}
										type="number" 
										name="hhi" 
										value={this.state.user.hhi}
										onChange={this.handleChange}>
									</Input>
								</div>

								<div id="ethnicity-field" className="input-field col s6 ethnicity-field">
									<Input 
										id='ethnicity' 
										type='select' 
										label={this.props.intl.formatMessage(localeMessages.ethnicity)}
										multiple={true} 
										value={this.state.user.ethnicity}
										onChange={this.handleEthnicitySelect}
									>
										<option value="" disabled>{this.props.intl.formatMessage(localeEthnicity.select)}</option>
										<option value="AA">{this.props.intl.formatMessage(localeEthnicity.african_american)}</option>
										<option value="AI">{this.props.intl.formatMessage(localeEthnicity.asian_indian)}</option>
										<option value="LH">{this.props.intl.formatMessage(localeEthnicity.latino)}</option>
										<option value="ME">{this.props.intl.formatMessage(localeEthnicity.middle_eastern)}</option>
										<option value="W">{this.props.intl.formatMessage(localeEthnicity.white)}</option>
										<option value="O">{this.props.intl.formatMessage(localeEthnicity.other)}</option>
										<option value="NA">{this.props.intl.formatMessage(localeEthnicity.decline)}</option>
									</Input>
									{/* <select id="ethnicity" multiple value={this.state.user.ethnicity}>
									</select>
									<label htmlFor="ethnicity">Ethnicity</label> */}
								</div>

								<div id="education-field" className="input-field col s6 education-field">
									<Input 
										id='education' 
										type='select' 
										label={this.props.intl.formatMessage(localeMessages.education)}
										value={this.state.user.education}
										onChange={this.handleEducationSelect}
									>
										<option value="" disabled>{this.props.intl.formatMessage(localeEducation.select)}</option>
										<option value={0}>{this.props.intl.formatMessage(localeEducation.some_high_school)}</option>
										<option value={1}>{this.props.intl.formatMessage(localeEducation.high_school)}</option>
										<option value={2}>{this.props.intl.formatMessage(localeEducation.some_college)}</option>
										<option value={3}>{this.props.intl.formatMessage(localeEducation.college)}</option>
										<option value={4}>{this.props.intl.formatMessage(localeEducation.post_graduate)}</option>
									</Input>
								</div>
								
								<div className="confirmation-row">
									<p className={"profile-message" + (this.state.displayDemographicsSuccess ? " success" : "")}>
										{this.props.intl.formatMessage(localeMessages.password_updated)}
									</p>
									<Button className="waves-effect waves-light" 
										type='submit'
										onClick={this.updateUserDemographics}>
										<FormattedMessage
											id="profile.button.update_information"
											defaultMessage={`Update Info`}
										/>							
									</Button>
								</div>
							</div>
						</form>
					</div>

					{/* <div className="pilotly-profile-account-settings">
						<p className="m-0 mt-15"><b>Privacy Settings</b></p>
						<div className="input-field col s6 m-0">
							<Input id="email-activities" 
								name="feedback_basic" 
								type="checkbox" 
								className="filled-in"
								label={this.props.intl.formatMessage(localeMessages.email_activity)}
								checked={this.state.user.feedback_basic}
								onChange={this.handleProfilePrivacy}>
							</Input>
						</div>
						<div className="input-field col s6">
							<Input id="email-updates"
								name="feedback_pro"
								type="checkbox"
								className="filled-in"
								label={this.props.intl.formatMessage(localeMessages.email_updates)}
								checked={this.state.user.feedback_pro}
								onChange={this.handleProfilePrivacy}>
							</Input>
						</div>
					</div> */}
				</div>
			</FadeIn>
		);
	}
}

function mapStateToProps(state) {
	return {
		currentUser: state.currentUser.currentUser,
		userPilotlyPoints: state.currentUser.userPilotlyPoints,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setCurrentUser
	}, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Profile));


// WEBPACK FOOTER //
// ./src/components/home/Profile.js